import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {TypeaheadComponent} from './typeahead.component';
import {TypeaheadOptionComponent} from './typeahead-option.component';
import {TypeaheadDirective} from './typeahead.directive';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    TypeaheadComponent,
    TypeaheadOptionComponent,
    TypeaheadDirective,
  ],
  exports: [
    TypeaheadComponent,
    TypeaheadOptionComponent,
    TypeaheadDirective,
  ]
})
export class TypeaheadModule {}
